import { render, staticRenderFns } from "./ClassView.vue?vue&type=template&id=8f5b7a8e&"
import script from "./ClassView.vue?vue&type=script&lang=js&"
export * from "./ClassView.vue?vue&type=script&lang=js&"
import style0 from "./ClassView.vue?vue&type=style&index=0&id=8f5b7a8e&prod&lang=scss&"
import style1 from "./ClassView.vue?vue&type=style&index=1&id=8f5b7a8e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports